// Native & external imports
import { Component, OnDestroy, OnInit, inject } from "@angular/core";
// Services
import { LayoutService } from "src/services/layout.service";
import { CmpAppSettings } from "src/services/cmp-app-settings.service";

@Component({
  standalone: false,
  selector: "cmp-privacy-policy",
  templateUrl: "./privacy-policy.component.html",
})
export class PrivacyPolicyComponent implements OnInit, OnDestroy {
  private layoutService = inject(LayoutService);
  private cmpAppSettings = inject(CmpAppSettings);

  public companyName = "";
  public privacyPolicy: { [index: string]: string | boolean } = {};

  constructor() {
    this.layoutService.noNavBar = true;
  }

  ngOnInit() {
    this.layoutService.containerClass = "container";
    this.privacyPolicy.loading = true;
    this.layoutService.getPrivacyPolicy().then((response) => {
      if (response) {
        this.privacyPolicy.value = response.settingValue;
      }
      this.privacyPolicy.loading = false;
    });
    this.companyName = this.cmpAppSettings.getAppSetting("companyName");
  }
  ngOnDestroy() {
    this.layoutService.noNavBar = false;
  }
}
